export const GET_CONTRACT_REQUEST =
  'user.borrower.loan_contract.GET_CONTRACT_REQUEST'
export const GET_CONTRACT_SUCCESS =
  'user.borrower.loan_contract.GET_CONTRACT_SUCCESS'
export const GET_CONTRACT_FAILURE =
  'user.borrower.loan_contract.GET_CONTRACT_FAILURE'
